import React from "react";
import {
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";
import { formatDateAsString, formatStatName, months } from "../helpers";
import get from "lodash/get";

export default function JobSnapshotsGraph({
  stats,
  height,
}: {
  stats?: JobStats;
  height?: number;
}) {
  if (stats && stats.snapshots && stats.snapshots.length > 0) {
    let lastSnapshot = { s: { engagements: 0 } };
    let lastDiff = 0;
    const chartData = stats.snapshots
      .map((snapshot) => {
        let diffEng = snapshot.s.engagements - lastSnapshot.s.engagements;
        // when going down return the data from the last snapshot
        if (diffEng <= 0) {
          return null;
        }
        let diffStats = Object.keys(snapshot.s)
          .filter((key) => key !== "engagements" && key !== "snapshots")
          .reduce((res, key) => {
            const fieldDiff = lastSnapshot.s[key]
              ? snapshot.s[key] - lastSnapshot.s[key]
              : snapshot.s[key];
            if (fieldDiff >= 0) {
              res[key] = fieldDiff;
            }
            return res;
          }, {});
        lastSnapshot = snapshot;
        return {
          time: snapshot.d.toDate().getTime(),
          value: diffEng,
          diffStats,
        };
      })
      .filter((i) => i !== null);
    return <TimeSeriesChart chartData={chartData} height={height} />;
  }
  return null;
}

const TimeSeriesChart = ({ chartData, height }) => (
  <ResponsiveContainer width="95%" height={height || 260}>
    <AreaChart data={chartData}>
      <defs>
        <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor="#3a86ff" stopOpacity={0.8} />
          <stop offset="95%" stopColor="#8338ec" stopOpacity={0} />
        </linearGradient>
      </defs>
      <XAxis
        dataKey="time"
        domain={["auto", "auto"]}
        name="time"
        tickFormatter={(timestamp) =>
          formatDateForSnapshot(new Date(timestamp))
        }
        tick={{ fontSize: "10px" }}
        type="number"
        tickLine={false}
      />
      <YAxis
        dataKey="value"
        name="engagements' pace"
        tick={{ fontSize: "10px" }}
        width={14}
        tickLine={false}
        axisLine={false}
      />
      <Tooltip
        cursor={{ strokeDasharray: "3 3" }}
        content={<CustomTooltip />}
      />
      <Area
        type="monotone"
        dataKey="value"
        stroke="#3a86ff"
        fillOpacity={1}
        fill="url(#colorValue)"
      />
      <CartesianGrid strokeDasharray="3 3" />
    </AreaChart>
  </ResponsiveContainer>
);

function formatDateForSnapshot(d: Date): string {
  return `${months[d.getMonth()]} ${d.getDate()}`;
}

function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    const diffStats = get(payload[0], "payload.diffStats");
    const total = payload[0].value;
    return (
      <div style={{ background: "var(--tone-down0)" }} className="p05 fz08">
        <small className="block">
          <strong>{total > 0 ? `+${total}` : total} </strong>(
          {formatDateAsString(new Date(payload[0].payload.time))})
        </small>
        {/* {diffStats && (
          <small className="block">
            {Object.keys(diffStats)
              .filter((key) => diffStats[key] !== 0)
              .map((key) => {
                const percent = Math.floor(
                  (Math.max(0, diffStats[key]) / total) * 100
                );
                return `${formatStatName(key)}: ${percent}%`;
              })
              .join(", ")}
          </small>
        )} */}
      </div>
    );
  }

  return null;
}
